<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';
import CreatePortalDialog from 'dashboard/components-next/HelpCenter/PortalSwitcher/CreatePortalDialog.vue';

const { t } = useI18n();
const createPortalDialogRef = ref(null);

const openDialog = () => {
  createPortalDialogRef.value.dialogRef.open();
};

const router = useRouter();

const onPortalCreate = ({ slug: portalSlug, locale }) => {
  router.push({
    name: 'portals_articles_index',
    params: { portalSlug, locale },
  });
};
</script>

<template>
  <div
    class="flex items-center justify-center h-full min-h-[300px] bg-n-surface-1"
  >
    <div class="flex flex-col items-center gap-4 max-w-md text-center">
      <div
        class="flex h-16 w-16 items-center justify-center rounded-2xl bg-n-slate-3"
      >
        <i class="i-lucide-library w-8 h-8 text-n-slate-11" />
      </div>
      <div class="flex flex-col gap-2">
        <h3 class="text-lg font-medium text-n-slate-12">
          {{ t('HELP_CENTER.TITLE') }}
        </h3>
        <p class="text-sm text-n-slate-11">
          {{ t('HELP_CENTER.NEW_PAGE.DESCRIPTION') }}
        </p>
      </div>
      <Button icon="i-lucide-plus" size="sm" @click="openDialog">
        {{ t('HELP_CENTER.NEW_PAGE.CREATE_PORTAL_BUTTON') }}
      </Button>
    </div>
    <CreatePortalDialog ref="createPortalDialogRef" @create="onPortalCreate" />
  </div>
</template>
